define('storageUtil',[
  'jquery',
  'cookies',
  'lib/util/langFromUrl',
  'lib/util/tda.config',
  'lib/getParameterByName',
  'lib/util/zip',
], function (
  $,
  cookies,
  langFromUrl,
  tdaConfig,
  getParameterByName,
  zip
) {
  // STORAGE UTILITY EXISTS, BAIL. // BAT-2360;
  if (window.SU) { return; }

  // storage utility
  var storageUtil = {

    init: function () {
      var self = this;
      self.setTDA();
      self.setTmsAttr();
    },

    /*
      tmsSiteAttribute is an option for TDAs to include in marketing links.
      It can be set from ANY page on BAT via queryString.
        It can also have a default configuration from TeamSite.
        default configuration is overwritten via QS/cookie
      It's used by BAT SLP forms to track if their marketing links resulted in a new SLP lead.
      TODO: move this outt here
        set DOM node value only on SLP pages that need it
    */
    setTmsAttr: function () {
      var tmsSiteAttr = getParameterByName('tmsSiteAttribute');
      var expireDays = $('#defaultzipcode').attr('tmssiteattrexpire');
      if (expireDays === '') {
        expireDays = 1;
      } else {
        expireDays = Number(expireDays);
      }

      if (tmsSiteAttr) {
        cookies.setItem('TMSSiteAttr', tmsSiteAttr, 60 * 60 * 24 * expireDays, '/');
        $('#tmsSiteAttribute').attr('value', tmsSiteAttr);
      } else {
        tmsSiteAttr = cookies.getItem('TMSSiteAttr');
        if (tmsSiteAttr) {
          $('#tmsSiteAttribute').attr('value', tmsSiteAttr);
        }
      }
    },

    queryStringFromHash: function (path) {
      if (path === '') {
        return '';
      }
      var curHref = path.replace('#', '').replace('?', '');
      var paramsObj = JSON.parse('{"' + decodeURI(curHref).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}');
      return paramsObj;
    },

    removeKeyValuePairFromQueryString: function (queryString, searchKey) {
      var newQueryString = queryString;
      var tempQueryStringPairs = [];
      var pairs;
      var foundValue;
      var i;
      var pairsLength;
      var testKeyValuePair;

      if (queryString && queryString.length) {
        // strip ? from beginning of queryString
        if (0 == queryString.indexOf('?')) queryString = queryString.substring(1);
        // translate all &amp; into & ('g' flag for global)
        queryString = queryString.replace('&amp;', '&', 'g');

        pairs = queryString.split('&');
        for (i = 0, pairsLength = pairs.length; i < pairsLength; i++) {
          testKeyValuePair = pairs[i].split('=');

          if (testKeyValuePair.length == 2) {
            if (testKeyValuePair[0] != searchKey) {
              // not the searchKey to exclude
              tempQueryStringPairs.push(testKeyValuePair[0] + '=' + testKeyValuePair[1]);
            }
          }
        }

        // rebuild querystring
        newQueryString = (tempQueryStringPairs.length) ? '?' : '';
        newQueryString += tempQueryStringPairs.join('&');
      }

      return newQueryString;
    },

    // checkers >>
    checkLocalStorage: function (key) {
      if (localStorage.getItem(key) !== null) {
        return true;
      }
      return false;
    },

    checkSessionStorage: function (key) {
      if (sessionStorage.getItem(key) !== null) {
        return true;
      }
      return false;
    },

    // setters >>
    setTDA: function () {
      var self = this;
      if ($('#region-name').length > 0) {
        try {
          localStorage.setItem('tdaCode', $('#region-name').data().tdaCode);
        } catch (e) {
          // BAT-2539
          if (e.toString() === 'Error: QuotaExceededError: DOM Exception 22' || e.toString() === 'QuotaExceededError (DOM Exception 22): The quota has been exceeded.') {
            self.localStorageError = true;
            cookies.setItem('tdaCode', $('#region-name').data().tdaCode, new Date(Date.now() + (365 * 24 * 60 * 60 * 1000)), '/');
          }
        }
      } else if ($('#all-offers[data-tdacode]').length > 0) {
        try {
          localStorage.setItem('tdaCode', $('#all-offers').data().tdacode);
        } catch (e) {
          // alert("6");
        }
      } else {
        // console.log("no TDA region available");
      }
    },

    setConfirmedZip: function (isConfirmedZip) {
      if (isConfirmedZip) {
        // zip is already confirmed, lets confirm again to update the 'isConfirmedZip' cookie
        cookies.setItem('isConfirmedZip', 'true', new Date(Date.now() + (365 * 24 * 60 * 60 * 1000)), '/', window.zipTools.getCrossDomainCookieDomain());
        // console.log('confirmed zip is: ', SU.getZip());
        /*--------------------------------------------------------------------------------------------
         Set a statename cookie, only if it doesn't exist
          If typeof SU.getState() is NOT a string, that means the cookie does NOT exist
          so let's set it. We do this to avoid another google Maps call.
          Note: if we're changing a zip, user may also be kicked to stateName() via _changeZipComplete()
          prior to reaching here.
        ----------------------------------------------------------------------------------------------*/
        if (typeof SU.getState() !== 'string') {
          window.zipTools.stateName();
        } else {
          // keep the stateNameplate updated:
          window.zipTools.stateNameplate(SU.getState());
        }
      } else {
        cookies.setItem('isConfirmedZip', 'false', new Date(Date.now() + (365 * 24 * 60 * 60 * 1000)), '/', window.zipTools.getCrossDomainCookieDomain());
      }
    },

    setZip: function (value) {
      // save value
      // localStorage.setItem('zip', value);
      // testing as a cookie
      var nextYear = new Date(Date.now() + (365 * 24 * 60 * 60 * 1000));
      cookies.setItem('zip', String(value), nextYear, '/', window.zipTools.getCrossDomainCookieDomain());
      cookies.setItem('zipcode', String(value), nextYear, '/', window.zipTools.getCrossDomainCookieDomain());
    },

    setLatLong: function (latitude, longitude) {
      try {
        localStorage.setItem('lat', latitude);
        localStorage.setItem('long', longitude);
      } catch (e) {
        // alert("7");
      }
    },

    setState: function (value) {
      cookies.setItem('state', String(value), new Date(Date.now() + (365 * 24 * 60 * 60 * 1000)), '/');
    },

    setLocalStorage: function (key, value) {
      // console.log('set local storage key:', key, 'value:', value);
      try {
        localStorage.setItem(key, value);
      } catch (e) {
        // alert("9");
      }
    },

    setSessionStorage: function (key, value) {
      // console.log('set session storage key:', key, 'value:', value);
      // console.trace();
      try {
        sessionStorage.setItem(key, value);
      } catch (e) {
        // alert("10");
      }
    },

    setInventoryData: function (object) {
      try {
        localStorage.setItem('inventoryData', object);
      } catch (e) {
        // alert("11");
      }
    },


    // getters >>
    isConfirmedZip: function () {
      return (cookies.getItem('isConfirmedZip') === 'true');
    },

    getTDA: function () {
      // var self = this;
      // if (this.checkLocalStorage('tdaCode')) {
      // 	return localStorage.getItem('tdaCode');
      // } else if ($("#all-offers[data-tdacode]").length > 0) {
      // 	return $("#all-offers").data().tdacode;
      // } else if(self.localStorageError){ //BAT-2539
      // 	return cookies.getItem('tdaCode');
      // } else {
      // 	return '';
      // }
      return tdaConfig.tda.code;
    },

    // shime for US.getZip()
    // TODO: replace usage of SU.getZip() with zip.getgetCookiedDefaultFallback()
    getZip: function () {
      return zip.getCookiedDefaultFallback();
    },

    getLat: function () {
      if (this.checkLocalStorage('lat')) {
        return localStorage.getItem('lat');
      }
      return '';
    },

    getLong: function () {
      if (this.checkLocalStorage('long')) {
        return localStorage.getItem('long');
      }
      return '';
    },

    getState: function () {
      return cookies.getItem('state');
    },

    getLocalStorage: function (key) {
      return localStorage.getItem(key);
    },

    getSessionStorage: function (key) {
      return sessionStorage.getItem(key);
    },

    // This needs to be removed once SLP supports query params
    setVehicleSpecs: function (obj) {
      this.setSessionStorage('year', obj.model_year);

      // set series name
      // make all lowercase and strip whitespaces
      var formattedSeriesName = obj.series_name.toLowerCase();
      formattedSeriesName = formattedSeriesName.replace(/ /g, '');

      // check for FJ Cruiser
      if (formattedSeriesName === 'fj') {
        formattedSeriesName = 'fjcruiser';
      }
      this.setSessionStorage('series', formattedSeriesName);

      // Grade
      for (var i = 0; i < obj.attributes_list.length; i++) {
        if (obj.attributes_list[i].split('|')[1] === 'GRADE') {
          // console.log("GRADE FOUND! ", obj.attributes_list[i].split("|")[0]);
          this.setSessionStorage('model', obj.attributes_list[i].split('|')[0]);
        }
      }

      // Trim Code
      this.setSessionStorage('trim', obj.model_code);
    },

    getInventoryData: function () {
      if (this.checkLocalStorage('inventoryData')) {
        return localStorage.getItem('inventoryData');
      } else {
        return '';
      }
    },

    // Added for BOS-103
    getDocHeight: function () {
      var D = document;
      return Math.max(
        D.body.scrollHeight, D.documentElement.scrollHeight,
        D.body.offsetHeight, D.documentElement.offsetHeight,
        D.body.clientHeight, D.documentElement.clientHeight
      );
    },

    // Added for NCA-76, NCA-78 and TRE-15 - Ends
    getRequests: function () {
      var s1 = location.search.substring(1, location.search.length).split('&');
      var r = {};
      var s2; var i;
      for (i = 0; i < s1.length; i += 1) {
        s2 = s1[i].split('=');
        r[decodeURIComponent(s2[0]).toLowerCase()] = decodeURIComponent(s2[1]);
      }
      return r;
    },

    // getValueFromWebStorage: function (itemName) {
    // 	var value = WebStorage.getSessionStorage().getItem(itemName);
    // 	if (value != '' && value != 'undefined' && typeof value !== 'undefined' && $.trim(value) != '') {
    // 		return value;
    // 	} else {
    // 		return '';
    // 	}
    // },

    getLangFromUrl: langFromUrl,

    swapLangInUrl: function (newLang) {
      var pathArr = window.location.href.split('/');
      var newLangString = newLang.substring(newLang.indexOf('/') + 1, newLang.length);
      var newLangFinal = newLangString.substring(0, newLangString.indexOf('/'));
      var newPathName = '';

      pathArr.splice(0, 3); // drop first 3 parts of pathArr, (['http:', 'buyatoyota.com', ''])
      pathArr[0] = newLangFinal; // update first item in pathArr with lang to switch to

      // build new path name
      for (var i = 0; i < pathArr.length; i++) {
        newPathName += '/';
        newPathName += pathArr[i];
      }
      /*
      console.group('swapLangInUrl');
        console.log('pathArr: ', pathArr);
        console.log('newLangFinal: ', newLangFinal);
        console.log('newPathName: ', newPathName);
      console.groupEnd();
      */
      location.assign(newPathName);
    }
  };

  window.SU = storageUtil; // shim
  return storageUtil;
});

